<template>
  <ValidationObserver ref="organizationForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-form rel="organizationForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.email"
                  rules="required"
                  outlined
                  dense
                  label="E-mail"
                  data-cy="email"
                />
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="loading"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'AdministratorForm',
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
    }
  },
  methods: {
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
